import { useState, useEffect } from "react";
import { api } from "./api";

const TEMPLATES_BY_TYPE = {
  installation: [
    {id:"pack_sentinelle",  nom:"Pack Sentinelle",    icon:"📷", color:"#5b6ef8", desc:"Vidéosurveillance IP/HDCVI"},
    {id:"pack_flash",       nom:"Pack Flash Control", icon:"🚨", color:"#ef4444", desc:"Alarme intrusion Ajax"},
    {id:"pack_cash_box",    nom:"Pack Cash Box",      icon:"💰", color:"#6366f1", desc:"Caisse enregistreuse & TPE"},
    {id:"",                 nom:"Sans modèle",         icon:"📋", color:"#8899bb", desc:"PV libre"},
  ],
  maintenance: [
    {id:"maintenance",      nom:"Maintenance",         icon:"🔧", color:"#22d3a0", desc:"Visite périodique vidéosurveillance"},
    {id:"",                 nom:"Sans modèle",         icon:"📋", color:"#8899bb", desc:"PV libre"},
  ],
  reparation: [
    {id:"pack_sav",         nom:"Pack SAV",            icon:"🛠️", color:"#f59e0b", desc:"Alarme ou vidéosurveillance"},
    {id:"",                 nom:"Sans modèle",         icon:"📋", color:"#8899bb", desc:"PV libre"},
  ],
  inspection: [
    {id:"",                 nom:"Sans modèle",         icon:"📋", color:"#8899bb", desc:"PV libre"},
  ],
};

// Auto-select model when only 1 real option for the type
const AUTO_MODEL = { maintenance: "maintenance", reparation: "pack_sav", inspection: "" };

const TYPES = [
  {value:"installation", label:"⚡ Installation",     desc:"Pose d'équipement",    color:"#5b6ef8"},
  {value:"maintenance",  label:"🔧 Maintenance",      desc:"Visite périodique",    color:"#22d3a0"},
  {value:"reparation",   label:"🛠️ SAV / Dépannage",  desc:"Intervention curative",color:"#f59e0b"},
  {value:"inspection",   label:"🔍 Inspection",       desc:"Audit, vérification",  color:"#8899bb"},
];

const PRIOS = [
  {value:"low",    label:"🟢 Basse"},
  {value:"medium", label:"🔵 Moyenne"},
  {value:"high",   label:"🟡 Haute"},
  {value:"urgent", label:"🔴 Urgente"},
];

export default function ModalIntervention({ T, onClose, onCreated }) {
  const [clients, setClients] = useState([]);
  const [techniciens, setTechniciens] = useState([]);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({
    titre:"", client_id:"", technicien_id:"", date_intervention:"",
    heure:"", priorite:"medium", type:"installation", description:"", modele_pv:""
  });

  useEffect(() => {
    Promise.all([api.getClients(), api.getTechniciens()]).then(([cl,tc]) => {
      setClients(Array.isArray(cl)?cl:[]);
      setTechniciens(Array.isArray(tc)?tc:[]);
    });
  }, []);

  const up = (k,v) => setForm(p=>({...p,[k]:v}));
  const inp = (ex={}) => ({ background:T.bg, border:`1px solid ${T.border}`, borderRadius:9, padding:"10px 13px", color:T.text, fontSize:14, outline:"none", width:"100%", ...ex });

  const selectType = (typeVal) => {
    const autoModel = AUTO_MODEL[typeVal];
    setForm(p=>({...p, type:typeVal, modele_pv: autoModel !== undefined ? autoModel : ""}));
  };

  const handleSubmit = async () => {
    if (!form.titre || !form.client_id || !form.date_intervention) {
      setError("Titre, client et date sont obligatoires"); return;
    }
    setSaving(true); setError("");
    try {
      const dt = form.heure ? `${form.date_intervention}T${form.heure}:00` : `${form.date_intervention}T08:00:00`;
      const res = await api.createIntervention({
        titre:form.titre, description:form.description, client_id:form.client_id,
        technicien_id:form.technicien_id||null, date_intervention:dt,
        priorite:form.priorite, type:form.type, modele_pv:form.modele_pv||null
      });
      if (res.error) { setError(res.error); setSaving(false); return; }
      onCreated && onCreated(res);
      onClose();
    } catch(e) { setError("Erreur serveur"); }
    setSaving(false);
  };

  const templates = TEMPLATES_BY_TYPE[form.type] || TEMPLATES_BY_TYPE.inspection;

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(8,12,30,0.22)",backdropFilter:"blur(4px)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:16,padding:30,animation:"nx-modal-open 0.3s cubic-bezier(0.16,1,0.3,1) both",width:540,maxHeight:"92vh",overflowY:"auto"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
          <div>
            <div style={{fontSize:18,fontWeight:800,color:T.text}}>🔧 Nouvelle intervention</div>
            <div style={{fontSize:12,color:T.muted,marginTop:3}}>Étape {step}/2</div>
          </div>
          <button onClick={onClose} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:20}}>✕</button>
        </div>

        <div style={{height:3,background:T.border,borderRadius:2,marginBottom:22}}>
          <div style={{height:"100%",borderRadius:2,background:`linear-gradient(90deg,${T.accent},${T.purple})`,width:`${step*50}%`,transition:"width 0.3s"}}/>
        </div>

        {error && <div style={{background:`${T.danger}15`,border:`1px solid ${T.danger}40`,borderRadius:9,padding:"10px 14px",marginBottom:14,fontSize:13,color:T.danger}}>⚠ {error}</div>}

        {step===1 && (
          <div style={{display:"flex",flexDirection:"column",gap:16}}>

            {/* Titre */}
            <div style={{display:"flex",flexDirection:"column",gap:6}}>
              <label style={{fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.7px"}}>Titre *</label>
              <input value={form.titre} onChange={e=>up("titre",e.target.value)} placeholder="Ex : Installation Pack Sentinelle" style={inp()}/>
            </div>

            {/* Client */}
            <div style={{display:"flex",flexDirection:"column",gap:6}}>
              <label style={{fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.7px"}}>Client *</label>
              <select value={form.client_id} onChange={e=>up("client_id",e.target.value)} style={inp({cursor:"pointer"})}>
                <option value="">— Sélectionner —</option>
                {clients.map(c=><option key={c.id} value={c.id}>{c.nom||c.raison_sociale}{c.ville?` (${c.ville})`:""}</option>)}
              </select>
            </div>

            {/* Type d'intervention */}
            <div style={{display:"flex",flexDirection:"column",gap:8}}>
              <label style={{fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.7px"}}>Type d'intervention</label>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                {TYPES.map(t=>(
                  <div key={t.value} onClick={()=>selectType(t.value)}
                    style={{padding:"12px",borderRadius:10,border:`2px solid ${form.type===t.value?t.color:T.border}`,background:form.type===t.value?t.color+"15":"transparent",cursor:"pointer",transition:"all 0.15s"}}>
                    <div style={{fontSize:14,fontWeight:800,color:form.type===t.value?t.color:T.text}}>{t.label}</div>
                    <div style={{fontSize:11,color:T.muted,marginTop:2}}>{t.desc}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Modèle PV — filtré selon le type */}
            <div style={{display:"flex",flexDirection:"column",gap:8}}>
              <label style={{fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.7px"}}>
                📋 Modèle de PV
                <span style={{fontSize:10,fontWeight:400,color:T.muted,textTransform:"none",marginLeft:6,letterSpacing:0}}>
                  {templates.filter(t=>t.id!=="").length === 1 ? "— auto-sélectionné" : "— choisissez ci-dessous"}
                </span>
              </label>
              <div style={{display:"flex",flexDirection:"column",gap:7}}>
                {templates.map(tpl=>(
                  <div key={tpl.id} onClick={()=>up("modele_pv",tpl.id)}
                    style={{display:"flex",alignItems:"center",gap:12,padding:"11px 14px",borderRadius:10,border:`1.5px solid ${form.modele_pv===tpl.id?tpl.color:T.border}`,background:form.modele_pv===tpl.id?`${tpl.color}12`:"transparent",cursor:"pointer",transition:"all 0.15s"}}>
                    <span style={{fontSize:20,flexShrink:0}}>{tpl.icon}</span>
                    <div style={{flex:1}}>
                      <div style={{fontSize:13,fontWeight:700,color:form.modele_pv===tpl.id?tpl.color:T.text}}>{tpl.nom}</div>
                      <div style={{fontSize:11,color:T.muted}}>{tpl.desc}</div>
                    </div>
                    <div style={{width:18,height:18,borderRadius:"50%",border:`2px solid ${form.modele_pv===tpl.id?tpl.color:T.border}`,background:form.modele_pv===tpl.id?tpl.color:"transparent",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                      {form.modele_pv===tpl.id&&<div style={{width:6,height:6,borderRadius:"50%",background:"#fff"}}/>}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Description */}
            <div style={{display:"flex",flexDirection:"column",gap:6}}>
              <label style={{fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.7px"}}>Description</label>
              <textarea value={form.description} onChange={e=>up("description",e.target.value)} placeholder="Détails..." rows={3} style={{...inp(),resize:"vertical",lineHeight:1.5}}/>
            </div>
          </div>
        )}

        {step===2 && (
          <div style={{display:"flex",flexDirection:"column",gap:14}}>
            {/* Récap type + modèle sélectionné */}
            <div style={{background:T.accentDim,border:`1px solid ${T.accent}30`,borderRadius:10,padding:"10px 14px",display:"flex",gap:12,alignItems:"center"}}>
              {(() => {
                const tpl = (TEMPLATES_BY_TYPE[form.type]||[]).find(t=>t.id===form.modele_pv);
                const tp = TYPES.find(t=>t.value===form.type);
                return <>
                  <span style={{fontSize:22}}>{tpl?.icon||"📋"}</span>
                  <div>
                    <div style={{fontSize:13,fontWeight:800,color:T.text}}>{tpl?.nom||"Sans modèle"}</div>
                    <div style={{fontSize:11,color:T.muted}}>{tp?.label} · {form.titre}</div>
                  </div>
                </>;
              })()}
            </div>

            <div style={{display:"flex",flexDirection:"column",gap:8}}>
              <label style={{fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.7px"}}>Priorité</label>
              <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8}}>
                {PRIOS.map(p=>(
                  <div key={p.value} onClick={()=>up("priorite",p.value)}
                    style={{padding:"9px 6px",borderRadius:9,border:`1.5px solid ${form.priorite===p.value?T.accent:T.border}`,background:form.priorite===p.value?T.accentDim:"transparent",cursor:"pointer",textAlign:"center",fontSize:11,fontWeight:700,color:form.priorite===p.value?T.accent:T.muted}}>
                    {p.label}
                  </div>
                ))}
              </div>
            </div>

            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
              <div style={{display:"flex",flexDirection:"column",gap:6}}>
                <label style={{fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.7px"}}>Date *</label>
                <input type="date" value={form.date_intervention} onChange={e=>up("date_intervention",e.target.value)} style={inp()}/>
              </div>
              <div style={{display:"flex",flexDirection:"column",gap:6}}>
                <label style={{fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.7px"}}>Heure</label>
                <input type="time" value={form.heure} onChange={e=>up("heure",e.target.value)} style={inp()}/>
              </div>
            </div>

            <div style={{display:"flex",flexDirection:"column",gap:8}}>
              <label style={{fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.7px"}}>Technicien</label>
              <select value={form.technicien_id} onChange={e=>up("technicien_id",e.target.value)} style={inp({cursor:"pointer"})}>
                <option value="">— Non assigné —</option>
                {techniciens.map(t=><option key={t.id} value={t.id}>{t.prenom} {t.nom}</option>)}
              </select>
            </div>
          </div>
        )}

        <div style={{display:"flex",gap:10,marginTop:22}}>
          {step===1 ? (
            <>
              <button onClick={onClose} style={{flex:1,padding:"11px",borderRadius:10,border:`1px solid ${T.border}`,background:"transparent",color:T.muted,fontSize:14,fontWeight:600,cursor:"pointer"}}>Annuler</button>
              <button onClick={()=>{if(!form.titre||!form.client_id){setError("Titre et client requis");return;}setError("");setStep(2);}}
                style={{flex:2,padding:"11px",borderRadius:10,background:T.accent,border:"none",color:"#fff",fontSize:14,fontWeight:700,cursor:"pointer"}}>
                Suivant →
              </button>
            </>
          ) : (
            <>
              <button onClick={()=>{setStep(1);setError("");}} style={{flex:1,padding:"11px",borderRadius:10,border:`1px solid ${T.border}`,background:"transparent",color:T.muted,fontSize:14,fontWeight:600,cursor:"pointer"}}>← Retour</button>
              <button onClick={handleSubmit} disabled={saving}
                style={{flex:2,padding:"11px",borderRadius:10,background:`linear-gradient(135deg,${T.accent},${T.purple})`,border:"none",color:"#fff",fontSize:14,fontWeight:700,cursor:"pointer",opacity:saving?0.7:1}}>
                {saving?"Création...":"✓ Créer l'intervention"}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
